import { render, staticRenderFns } from "./liens.vue?vue&type=template&id=4d663cd7&"
import script from "./liens.vue?vue&type=script&lang=js&"
export * from "./liens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports